<template>
  <DocumentList :document-service="EntityDocumentService">
    <template #pageHeader>
      <div>
        <EntityShowHeader :entity="entity" />
        <DocumentResourceNav :resource="'entities'" />
      </div>
    </template>
  </DocumentList>
</template>

<script>
import EntityShowHeader from '@/Modules/Entity/Components/EntityShowHeader.vue'
import EntityService from '@/Modules/Entity/EntityService.js'
import EntityDocumentService from '@/Modules/Entity/EntityDocument/EntityDocumentServiceOneDrive.js'
import DocumentResourceNav from '@/Modules/Document/Components/OneDrive/DocumentResourceNav.vue'
import LazyLoadComponent from '@/General/LazyLoadComponent.js'
import DocumentList from '@/Modules/Document/Components/OneDrive/DocumentList.vue'

export default {
  name: 'List',

  components: { EntityShowHeader, DocumentResourceNav, DocumentList },

  extends: LazyLoadComponent((to, callback) => {
    EntityService.show(to.params.entityId).then((entity) => {
      callback(function () {
        this.entity = entity
      })
    })
  }),

  data() {
    return {
      entity: {},
      EntityDocumentService,
    }
  },
}
</script>
